import { render, staticRenderFns } from "./PasswordResetSent.vue?vue&type=template&id=8f5565ac&"
import script from "./PasswordResetSent.vue?vue&type=script&lang=js&"
export * from "./PasswordResetSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports